import config from '../config.json';
import axios from 'axios';

export class ContaAzulService {
    setup = async (payload) => {
        return (await axios.post(`${config.BASE_URL}contaazul`, payload));
    }

    listAccount = async () => {
        return (await axios.get(`${config.BASE_URL}contaazul/banks`)).data;
    }
}